// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Lock Icon.
 * @param {IconProps} props - The IconProps for the LockIcon component.
 * @returns {ReactElement} The LockIcon component.
 */
export const LockIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon viewBox='0 0 34 38' color={color} {...rest} id='lock-icon'>
      <path
        d='M0 19.0002C0 16.3803 2.12637 14.2502 4.75 14.2502H28.5C31.1199 14.2502 33.25 16.3803 33.25 19.0002V33.2502C33.25 35.8702 31.1199 38.0002 28.5 38.0002H4.75C2.12637 38.0002 0 35.8702 0 33.2502V19.0002Z'
        fill='currentColor'
      />
      <path
        opacity='0.5'
        d='M16.625 4.75024C13.3445 4.75024 10.6875 7.40876 10.6875 10.6877V14.2502H5.9375V10.6877C5.9375 4.78513 10.7246 0.000244141 16.625 0.000244141C22.5254 0.000244141 27.3125 4.78513 27.3125 10.6877V14.2502H22.5625V10.6877C22.5625 7.40876 19.9055 4.75024 16.625 4.75024Z'
        fill='currentColor'
      />
    </Icon>
  );
};
